import Class from './program-monitor2';
import './program-monitor2@';

export default Class;